module.exports = __webpack_public_path__ + "static/media/background-oeuvres.0b966330.jpg";